{
  "uploadLogo": "subir logo",
  "Link": "Enlace",
  "UploadTips": "Recomendamos como mínimo que las imágenes tengan una resolución de 1056 x 192 píxeles. Para obtener los mejores resultados, sube imágenes con una resolución de 2560 x 192 píxeles.",
  "selectLogo": "elige logo",
  "selectImage": "seleccionar imagen",
  "errorMessage": "Se ha producido un error al validar algunos de sus correos electrónicos. Utiliza solo comas , punto y coma o espacios para separar las direcciones de correo electrónico .",
  "emailAlreadyAddedError": " ya se ha agregado.",
  "emailNotValidError": " no es una dirección de correo electrónico válida.",
  "ImageNotSupported": "El formato de imagen no es compatible.",
  "SupportedFormats": "El formato de imagen no es compatible. Los formatos admitidos son jpg, jpeg, png, gif y jfif.",
  "ImageFailedToUpload": "No se pudo cargar la imagen. Inténtelo de nuevo más tarde.",
  "firstName": "Nombre",
  "lastName": "Apellidos",
  "Purpose": "Propósito",
  "add": "añadir",
  "AddAlternativeEmail": "Agregar un correo electrónico alternativo",
  "AvatarUploadHeadingPart1": "Seleciona tu",
  "Photo": "foto",
  "select": "seleciona",
  "PhotoLimit": "Buena foto, pero supera el tamaño máximo: 10 MB.",
  "SkipForNow": "saltar por ahora",
  "SponsorNameRequired": "Se requiere el nombre del patrocinador",
  "URLvalidation": "Introduce una URL válida",
  "fileRequired": "Se requiere un archivo",
  "InputLabel1": "Nombre de la empresa patrocinadora",
  "InputLabel1Placeholder": "Nombre de la empresa patrocinadora (requerido)",
  "InputLabel2": "Sitio web",
  "delete": "Eliminar",
  "UpdateSponsor": "Actualizar patrocinador",
  "AddSponsor": "Agregar patrocinador",
  "SponsorAdded": "Patrocinador agregado correctamente.",
  "SelectLogo": "Seleccionar logo",
  "AddSponsorButton": "Añadir patrocinador",
  "SponsorUpdated": "Patrocinador actualizado correctamente.",
  "SponsorDeleted": "Patrocinador eliminado correctamente.",
  "ValidateAwardType": "Selecciona el tipo de premio",
  "ValidateProject": "Seleccionar un proyecto",
  "ConfirmAwards": "Confirmar premios",
  "ConfirmAwardsMessage": "¿Estás seguro? No podrás cambiar esto más tarde.",
  "goBackButton": "No, vuelve atrás",
  "YesSubmitButton": "Si, envíalo",
  "AwardOption1": "Solo uno",
  "AwardOption2": "Ganador y finalista",
  "AwardOption3": "3 primeros",
  "title": "Cuantos ganadores?",
  "SelectHowMany": "Selecciona cuantos",
  "SelectProject": "Seleccionar Proyecto",
  "SubmitButton": "Enviar",
  "duplicateProjectWarning": "No se permite la selección de proyectos duplicados.",
  "ChangeTeamRoleStep1": "Hacer",
  "ChangeTeamRoleStep2": "Seleccionar Rol",
  "SaveButton": "Guardar ",
  "save+next": "guardar + siguiente",
  "EditEventConfirm": "Confirmar para eliminar",
  "EditEventConfirmMessage": "¿Estás seguro de hacer esto?",
  "Yes": "Si",
  "No": "No",
  "EventNameRequired": "El nombre del evento es obligatorio",
  "EventTypeRequired": "El tipo de evento es obligatorio",
  "EditEventTitle": "Edita tu evento",
  "EventName": "Nombre del evento",
  "to": "a",
  "Online": "Online",
  "ClickHere": "¿Solo online? haz clic aquí",
  "EventType": "Selecciona un tipo de evento",
  "EventDescriptionPlaceholder": "Descripción del evento (máximo 250 caracteres)",
  "UpdateEventButton": "Actualizar Evento",
  "AddEventButton": "Añadir evento",
  "EventEndingError": "Oh no. Tu evento parece terminar antes de que haya comenzado.",
  "EventUpdatedMessage": "Evento actualizado.",
  "cancel": "cancelar",
  "updatedSuccessfully": "actualizado con éxito.",
  "addedSuccessfully": "agregado exitosamente.",
  "HubSettings": "Configuración del hub",
  "saveButtonPart2": " a la página del proyecto",
  "SaveImageButton": "Guardar {{imageType}} a la página del proyecto",
  "RoleTypeRequired": "Se requiere el tipo de rol",
  "InviteParticipantsTitle": "Invitar participantes",
  "InviteParticipantsPart1": "Invita a personas a participar y contribuir a tu evento.",
  "InviteParticipantsPart2": "Selecciona un rol",
  "InviteParticipantsPart3": "Seleccionar rol (s):",
  "InviteParticipantsPhrase1": "Rebel",
  "InviteParticipantsPhrase1Part2": "Trabajando en innovación",
  "InviteParticipantsPhrase2": "Seguidor",
  "InviteParticipantsPhrase2Part2": "Experiencia en inversiones",
  "or": "o",
  "InviteParticipantsPhrase3": "General",
  "InviteParticipantsPhrase3Part2": "Sin rol",
  "EnterEmailAddress": "Escriba una dirección de correo electrónico y presiona 'Enter'",
  "EnterEmailAddressPlaceholder": "Agrega varias direcciones de correo electrónico una a la vez",
  "PersonalizeInvitation": "Personaliza tu invitación con un mensaje",
  "AddMessage": "Agrega un mensaje personal que se enviará junto con tu invitación al evento...",
  "optional": "opcional",
  "Finish": "Terminar",
  "back": "atrás",
  "SelectRoleType": "selecciona el rol",
  "Invitations": "Invitaciones",
  "Send": "Enviar",
  "IncorrectEmailErrorMessage": "Oh no. Parece que estas escribiendo un correo electrónico incorrecto.",
  "TitleRequired": "Se requiere un título",
  "JudgeBioTitle": "Edita tu biografía",
  "TitlePlaceholder": "Título",
  "BioPlaceholder": "cuéntanos sobre tu hermoso tu",
  "updateButton": "actualizar",
  "addButton": "añadir",
  "BioUpdated": "Bio actualizado con éxito.",
  "BioAdded": "Bio agregado con éxito.",
  "Bio": "Biografía",
  "ManageParticipantTitle": "Invitar a",
  "PendingInvites": "Invitaciones pendientes",
  "sendANudge": "Recordar",
  "NoPendingInvitations": "No hay invitaciones pendientes",
  "Participants": "Participantes",
  "changeRole": "cambio de rol",
  "notePlaceholder": "Diles lo que piensas",
  "note": "Nota",
  "Please": "Por favor",
  "login": "iniciar sesión",
  "signup": "regístrate",
  "addNote": "para agregar una nota.",
  "permissionFormTitle": "Quien puede ver esto?",
  "permission1": "Solo equipo",
  "permission2": "Mis eventos",
  "permission3": "Mi hub, grupos, eventos",
  "permission4": "Cualquier persona",
  "CloseAbout": "Cerrar Acerca de",
  "CloseWarningMessage": "¿Seguro que quieres cerrar?",
  "YesCloseButton": "Si, cerrar",
  "closeButton": "Cerrar",
  "ProjectProfileFormPhrase1": "Este es tu patio de juegos.",
  "ProjectProfileFormPhrase2": "Capta la atención de tu audiencia con tu historia: quién eres, qué te esfuerzas por hacer y por qué debería importarnos ... Créeme, queremos saberlo.",
  "ProjectProfileFormPhrase3": "Invita a la gente a sumergirse en una experiencia de inmersión visual: usa videos atractivos y fotos creativas para pintar una imagen con más que solo palabras. Los proyectos contados a través de imágenes tienen más probabilidades de tener éxito.",
  "ImageSizeErrorMessage": "El tamaño de la imagen no debe superar los 3 MB.",
  "ProjectSettingsTitle": "Configuración del proyecto",
  "ProjectName": "Nombre del proyecto",
  "Industry": "Industria",
  "HideFromSearch": "¿Ocultar de la búsqueda?",
  "ResourceLabelRequired": "Se requiere etiqueta de recurso",
  "ResourceLabelUpdated": "Etiqueta de recurso actualizada correctamente.",
  "TemplateTitle": "Nombre de plantilla personalizada:",
  "TemplatePlaceholder": "Nombre de la plantilla",
  "OverwriteTemplate": "O elige la plantilla para sobrescribir:",
  "SelectTemplate": "Seleccionar plantilla",
  "NoCustomTemplate": "Sin plantilla personalizada para sobrescribir",
  "TemplateName": "Ingresa el nombre de la plantilla o selecciona una de la lista.",
  "TemplateNameCharLimit": "El nombre de la plantilla no debe exceder los 50 caracteres",
  "TemplateNameTaken": "El nombre de la plantilla ya está en uso.",
  "TemplatesSaved": "Plantillas guardadas correctamente",
  "NoProjectYet": "Aún no tienes ningún proyecto.",
  "CreateProject": "Crea un proyecto",
  "SelectProjectLater": "seleccionar proyecto más tarde",
  "SubmitProject": "enviar mi proyecto",
  "SelectProjectTitle": "SELECCIONAR PROYECTO PARA",
  "CurrentlySubmitted": "Enviado actualmente:",
  "SelectProjectFormPhrase1": "Todas",
  "SelectProjectFormPhrase1Part2": "los miembros del equipo recibirán una invitación",
  "SelectProjectFormPhrase2": "No tienes otro proyecto al que cambiarte.",
  "ok": "ok",
  "ProjectAdded": "Proyecto agregado exitosamente.",
  "SelectProjectCaps": "SELECCIONAR PROYECTO",
  "StartRoundFormTitle": "Proyectos puntuados en",
  "NoProjectsWarning": "Debe haber al menos un proyecto enviado antes de que se pueda abrir una ronda. Invita a los competidores al evento.",
  "NoJudgesWarning": "Debe haber al menos un juez antes de que se pueda abrir una ronda. Invita a los jueces al evento.",
  "StartRoundFormPhrase1": "seleccione al menos uno a continuación",
  "StartRoundFormPharse2": "Jueces en",
  "Round": "Ronda",
  "OpenRoundButton": "abre esta ronda!",
  "RoundOpened": "Ronda Abierta.",
  "SupportsUpdated": "Soportes Actualizados.",
  "LoadingYourContent": "Cargando tu contenido ...",
  "ImageSizeLimit": "Buena foto, pero supera el tamaño máximo: 5mb.",
  "ImageSizeLimit3mb": "Buena foto, pero supera el tamaño máximo: 3mb.",
  "SelectFeild": "Seleccionar un",
  "Type": "Tipo",
  "email": "correo electrónico",
  "phoneNumber": "número de teléfono",
  "countryRegion": "país/región",
  "companyName": "nombre de la empresa",
  "jobTitle": "puesto de trabajo",
  "datesAndTimes": "los días y las horas que le resulten más convenientes",
  "Submitting": "Enviando...",
  "EmailError1": "Introduzca una dirección de correo electrónico válida",
  "EmailError2": "El correo electrónico es obligatorio",
  "EnterValidPhoneNum": "Por favor, introduzca un número de teléfono válido",
  "MaxLimitError": "El límite máximo de caracteres es 250.",
  "questionAnswer": "Pregunta",
  "idea": "Idea",
  "announcement": "Anuncio",
  "post": "Post",
  "offer": "Oferta",
  "SuccesfullySent": "¡Sus invitaciones han sido enviadas!",
  "Invite People": "Invitar a la gente",
  "Add Email(s)": "Añadir correo(s) electrónico",
  "inviteSentMsg": "Las invitaciones han sido enviadas",
  "errorSendingInviteMsg": "Hubo problemas con algunos de los correos que proporcionaste, para más detalles",
  "errorSendingInvites": "Error al enviar invitaciones",
  "ClickHere": "Haz clic aquí",
  "Email": "Correo electrónico",
  "already member": "Ya eres miembro",
  "already invited": "Ya invitado",
  "invalid email": "Correo electrónico inválido",
  "invalidEmail": "Por favor ingresa un correo electrónico válido",
  "AddLocation": "Agregar una ubicación",
  "NoLocations": "Sin ubicaciones",
  "LocationSearchUnavailable": "La búsqueda de ubicaciones no está disponible en este momento. Inténtalo de nuevo.",
  "UnsavedChangesTitle": "¿Salir sin guardar?",
  "UnsavedChangesWarning": "Tienes cambios sin guardar en esta página. Si sales ahora se perderán.",
  "leave": "Salir",
  "stay": "Quedarme"
}
